import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackOnboardingButtonClick, trackOnboardingButtonShow } from './tracking';
import { setEditableMessage } from '../../actions/chat/actions';
import { ChatbotOnboardingButtonsLayout } from '../../components/ChatbotOnboardingButtonsLayout';
import { OnboardingButton } from '../../components/OnboardingButton';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { chatbotSelector } from '../../selectors';
import { EChatbotActionType } from '../../services/fetchChatbotActionButtons';
import { IChatbotOnboardingButtonSchema } from '../../types/chatbot';
import { useApplicationContext } from '../../utils/applicationContext';

type TOnboardingButtonContainerProps = {};

export const OnboardingButtonContainer: React.FC<TOnboardingButtonContainerProps> = () => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch();
  const { onboardingButtons } = useSelector(chatbotSelector);

  const isChatbotGPTEnabled = config.get<boolean>('frontend-chats.chatbotGPT.Enabled') || false;

  const onClick = React.useCallback(
    (onboardingButtonChatbot: IChatbotOnboardingButtonSchema) => {
      const { analyticsType, actionType, inputText } = onboardingButtonChatbot;

      trackOnboardingButtonClick(analyticsType);
      if (actionType === EChatbotActionType.CopyToInput && inputText) {
        dispatch(setEditableMessage({ chatId: CHATBOT_ID, text: inputText }));

        return;
      }
    },
    [dispatch],
  );

  React.useEffect(() => {
    if (onboardingButtons) {
      const analyticsType = onboardingButtons.map(({ analyticsType }) => analyticsType);

      trackOnboardingButtonShow(analyticsType);
    }
  }, [onboardingButtons]);

  const buttons =
    isChatbotGPTEnabled &&
    onboardingButtons &&
    onboardingButtons.map((onboardingButtonChatbot, index) => {
      return <OnboardingButton key={index} onboardingButton={onboardingButtonChatbot} onClick={onClick} />;
    });

  if (!buttons || !buttons.length) {
    return null;
  }

  return <ChatbotOnboardingButtonsLayout>{buttons}</ChatbotOnboardingButtonsLayout>;
};
